const CONVERSION_FACTOR = 1000

export const formatLongNumber = (num: number, fixed?: number) => {
  if (num === undefined || num === null) return '-'
  if (num < CONVERSION_FACTOR) return num.toFixed(fixed ?? 2)
  return `${(num / CONVERSION_FACTOR).toFixed(fixed ?? 2)}k`
}
